// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--zu8iJ","main-content":"a10a3f92e9--main-content--F0xpb","img":"a10a3f92e9--img--dse5I"};